<div class="d-grid gap-3" style="grid-template-columns: 350px 1fr" *ngIf="viewType !== 'table'">
  <app-automation-wizard-left
    [type]="type"
    (typeChange)="typeChange.emit($event)"
    image="/assets/images/automation-wizards/charge.webp"
  >
    <ng-container i18n
      >Charges represent costs incurred for services or bookings, such as additional fees or penalties. Actions involve
      notifying guests, tracking the charge status, and following up on failed payments. Managing charges ensures
      transparency and proper billing within the booking system.</ng-container
    >
  </app-automation-wizard-left>
  <div class="card shadow">
    <div class="card-header flex-column align-items-start p-3 bg-default2">
      <h6>What would you like to do when a charge is</h6>
      <div class="btn-group">
        <button
          type="button"
          (click)="onSelectEvent(events.ChargeCreated)"
          class="btn btn-sm"
          [ngClass]="selectedEvent === events.ChargeCreated ? 'btn-info' : 'btn-outline-light'"
          i18n
        >
          Created
        </button>
        <button
          type="button"
          (click)="onSelectEvent(events.ChargePaid)"
          class="btn btn-sm"
          [ngClass]="selectedEvent === events.ChargePaid ? 'btn-info' : 'btn-outline-light'"
          i18n
        >
          Successful
        </button>
        <button
          type="button"
          (click)="onSelectEvent(events.ChargeFailed)"
          class="btn btn-sm"
          [ngClass]="selectedEvent === events.ChargeFailed ? 'btn-info' : 'btn-outline-light'"
          i18n
        >
          Failed
        </button>
        <button
          type="button"
          (click)="onSelectEvent(events.ChargeDeleted)"
          class="btn btn-sm"
          [ngClass]="selectedEvent === events.ChargeDeleted ? 'btn-info' : 'btn-outline-light'"
          i18n
        >
          Deleted
        </button>
      </div>
    </div>
    <div class="card-body d-flex flex-column gap-3">
      <ng-container [ngSwitch]="selectedEvent">
        <ng-template *ngSwitchCase="events.ChargeCreated" [ngTemplateOutlet]="createdEvent"></ng-template>
        <ng-template *ngSwitchCase="events.ChargePaid" [ngTemplateOutlet]="paidEvent"></ng-template>
        <ng-template *ngSwitchCase="events.ChargeFailed" [ngTemplateOutlet]="failedEvent"></ng-template>
        <ng-template *ngSwitchCase="events.ChargeDeleted" [ngTemplateOutlet]="deletedEvent"></ng-template>
      </ng-container>
      <div class="flex-fill"></div>
      <app-automation-channel-rental-select
        [form]="form"
        [allowsChannel]="false"
      ></app-automation-channel-rental-select>
    </div>
  </div>
</div>

<div *ngIf="viewType === 'table'" class="d-flex flex-column gap-4 automation-table">
  <div class="table-view-header text-muted text-semi-bold">
    <div class="text-uppercase text-muted mb-0" i18n>What would you like to do when</div>
    <div i18n>Created Date • Time</div>
    <div i18n>Last Triggered Date • Time</div>
  </div>
  <div class="container-box shadow">
    <h6 class="text-uppercase m-0 px-3 py-2" i18n>Charge is Created</h6>
    <ng-template [ngTemplateOutlet]="createdEvent"></ng-template>
  </div>
  <div class="container-box shadow">
    <h6 class="text-uppercase m-0 px-3 py-2" i18n>Charge is Successful</h6>
    <ng-template [ngTemplateOutlet]="paidEvent"></ng-template>
  </div>
  <div class="container-box shadow">
    <h6 class="text-uppercase m-0 px-3 py-2" i18n>Charge is Failed</h6>
    <ng-template [ngTemplateOutlet]="failedEvent"></ng-template>
  </div>
  <div class="container-box shadow">
    <h6 class="text-uppercase m-0 px-3 py-2" i18n>Charge is Deleted</h6>
    <ng-template [ngTemplateOutlet]="deletedEvent"></ng-template>
  </div>
</div>

<ng-template #createdEvent>
  <app-notify-guest-automation
    [event]="events.ChargeCreated"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    i18n-name
    label="Notify guest"
    name="Notify the guest of charge creation"
    [messageSubject]="guestNotificationMessages[events.ChargeCreated].subject"
    [messageBody]="guestNotificationMessages[events.ChargeCreated].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-guest-automation>

  <app-notify-users-automation
    [event]="events.ChargeCreated"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    i18n-name
    label="Notify user(s)"
    name="Notify the user(s) of charge creation"
    [messageSubject]="userNotificationMessages[events.ChargeCreated].subject"
    [messageBody]="userNotificationMessages[events.ChargeCreated].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-users-automation>
</ng-template>

<ng-template #paidEvent>
  <app-do-action-automation
    [event]="events.ChargePaid"
    [type]="automationTypes.Booking"
    [viewType]="viewType"
    [eventSourceType]="type"
    [handler]="eventHandlers.BookingMarkPaid"
    i18n-label
    i18n-name
    i18n-customTooltip
    label="Update booking status as paid"
    name="Mark booking as paid when charge paid"
    customTooltip="Charge is considered as paid invoice therefore booking status will be marked as paid if the charged amount equals or exceeds the booking total."
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-do-action-automation>

  <app-notify-guest-automation
    [event]="events.ChargePaid"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    i18n-name
    label="Notify the guest"
    name="Notify the guest of successful charge"
    [messageSubject]="guestNotificationMessages[events.ChargePaid].subject"
    [messageBody]="guestNotificationMessages[events.ChargePaid].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-guest-automation>
</ng-template>

<ng-template #failedEvent>
  <app-notify-guest-automation
    [event]="events.ChargeFailed"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    i18n-name
    label="Notify the guest"
    name="Notify the guest of failed charge"
    [messageSubject]="guestNotificationMessages[events.ChargeFailed].subject"
    [messageBody]="guestNotificationMessages[events.ChargeFailed].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-guest-automation>

  <app-notify-users-automation
    [event]="events.ChargeFailed"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    i18n-name
    label="Notify the user(s)"
    name="Notify the user(s) of failed charge"
    [messageSubject]="userNotificationMessages[events.ChargeFailed].subject"
    [messageBody]="userNotificationMessages[events.ChargeFailed].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-users-automation>

  <app-do-action-automation
    [event]="events.ChargeFailed"
    [type]="automationTypes.Booking"
    [viewType]="viewType"
    [eventSourceType]="type"
    [handler]="eventHandlers.BookingMarkFollowUp"
    i18n-label
    i18n-name
    label="Mark the booking status for followup"
    name="Mark the booking status for followup when charge failed"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-do-action-automation>
</ng-template>

<ng-template #deletedEvent>
  <app-notify-guest-automation
    [event]="events.ChargeDeleted"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    i18n-name
    label="Notify the guest"
    name="Notify the guest when charge deleted"
    [messageSubject]="guestNotificationMessages[events.ChargeDeleted].subject"
    [messageBody]="guestNotificationMessages[events.ChargeDeleted].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-guest-automation>

  <app-notify-users-automation
    [event]="events.ChargeDeleted"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    i18n-name
    label="Notify the user(s)"
    name="Notify the user(s) when charge deleted"
    [messageSubject]="userNotificationMessages[events.ChargeDeleted].subject"
    [messageBody]="userNotificationMessages[events.ChargeDeleted].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-users-automation>
</ng-template>
